import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAddItemtoCartMutation } from "../redux/services/cart";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function ProductDetail({data}){
    const user = useSelector((state) => state.auth.user);

    let [count, setCount] = useState(1)
    const [selectedColor, setSelectedColor] = useState(data?.color?.[0] || null);
    const [selectedSize, setSelectedSize] = useState(data?.size?.[0] || null);
    const [addProductToCart] = useAddItemtoCartMutation();

    const increments = () =>{
        setCount(count + 1)
    }
    const decrements = () =>{
        if(count > 1){
        setCount(count - 1)
        }
    }
    const handleAddToCart = async (details) => {
        await addProductToCart({
          quantity: count,
          product_id: details.id,
          user_id: user.id,
          selected_color: selectedColor,
          selected_size: selectedSize
        });
        toast.success("Product added to cart");
      };

      console.log(data, "hoo")
    return(
        <div className="sticky top-20">
            <h5 className="text-2xl font-semibold">{data?.title}</h5>
            <div className="mt-2">
                <span className="text-slate-400 font-semibold me-1">${data?.sale_price} USD</span>
            </div>

            <div className="mt-4">
                <h5 className="text-lg font-semibold">Overview :</h5>
                <p className="text-slate-400 mt-2">{data?.description}</p>
            
                {/* <ul className="list-none text-slate-400 mt-4">
                    <li className="mb-1 flex ms-0"><i className="mdi mdi-check-circle-outline text-orange-500 text-xl me-2"></i> Digital Marketing Solutions for Tomorrow</li>
                    <li className="mb-1 flex ms-0"><i className="mdi mdi-check-circle-outline text-orange-500 text-xl me-2"></i> Our Talented & Experienced Marketing Agency</li>
                    <li className="mb-1 flex ms-0"><i className="mdi mdi-check-circle-outline text-orange-500 text-xl me-2"></i> Create your own skin to match your brand</li>
                </ul> */}
            </div>

            <div className="grid lg:grid-cols-2 grid-cols-1 gap-6 mt-4">
                {data?.size?.length && <div className="flex items-center">
                    <h5 className="text-lg font-semibold me-2">Size:</h5>
                    <div className="space-x-1">
                        {data?.size?.map((size,index) => 
                            <button 
                                key={index} 
                                onClick={() => setSelectedSize(size)}
                                className={`size-9 inline-flex items-center justify-center tracking-wide align-middle text-base text-center rounded-md ${selectedSize === size ? 'bg-orange-500 text-white' : 'bg-orange-500/5 hover:bg-orange-500 text-orange-500 hover:text-white'}`}
                            >
                                {size}
                            </button>
                        )}
                    </div>
                </div>}

                <div className="flex items-center">
                    <h5 className="text-lg font-semibold me-2">Quantity:</h5>
                    <div className="qty-icons ms-3 space-x-0.5">
                        <button onClick={()=>decrements()} className="size-9 inline-flex items-center justify-center tracking-wide align-middle text-base text-center rounded-md bg-orange-500/5 hover:bg-orange-500 text-orange-500 hover:text-white minus">-</button>
                        <input min="1" name="quantity" value={count} onChange={()=>{}} type="number" className="h-9 inline-flex items-center justify-center tracking-wide align-middle text-base text-center rounded-md bg-orange-500/5 hover:bg-orange-500 text-orange-500 hover:text-white pointer-events-none w-16 ps-4 quantity"/>
                        <button onClick={()=>increments()} className="size-9 inline-flex items-center justify-center tracking-wide align-middle text-base text-center rounded-md bg-orange-500/5 hover:bg-orange-500 text-orange-500 hover:text-white plus">+</button>
                    </div>
                </div>

                <div className="flex items-center">
                    <h5 className="text-lg font-semibold me-2">Colors:</h5>
                    <div className="space-x-2">
                    {data?.color?.map((col,index) => 
                        <button 
                            onClick={() => setSelectedColor(col)}
                            style={{background: col}} 
                            className={`size-6 rounded-full ring-2 ${selectedColor === col ? 'ring-orange-500' : 'ring-gray-200 dark:ring-slate-800'} inline-flex align-middle transition-all`} 
                            title={col} 
                            key={index}
                        />
                    )}
                    </div>
                </div>
            </div>

            <div className="mt-4 space-x-1">
                <button
                    onClick={(e)=>{
                        e.stopPropagation();
                        if (!user?.id) {
                            toast.warning("Please login to checkout");
                            return;
                        }
                        handleAddToCart(data);
                    }}
                    className="py-2 px-5 inline-block font-semibold tracking-wide align-middle text-base text-center bg-orange-500 text-white rounded-md mt-2"
                >
                    Shop Now
                </button>
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        if (!user?.id) {
                            toast.warning("Please login to add to cart");
                            return;
                        }
                        handleAddToCart(data);
                    }}
                    className="py-2 px-5 inline-block font-semibold tracking-wide align-middle text-base text-center rounded-md bg-orange-500/5 hover:bg-orange-500 text-orange-500 hover:text-white mt-2"
                >
                    Add to Cart
                </button>
            </div>
        </div>
    )
}